module.exports = __webpack_public_path__ + "img/index05.305676c7.jpg";